import { render, staticRenderFns } from "./AddPriceRecord.vue?vue&type=template&id=69b87e74&"
import script from "./AddPriceRecord.vue?vue&type=script&lang=js&"
export * from "./AddPriceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports